/**
 * 
 * @param cookies 
 * @returns 
 */
export const getSoleAuth = (cookies) => {
  return cookies.get('SoleAuth')
}

export const getUserIsLogged = (cookies) => {
  return !!getSoleAuth(cookies);
}

const getFieldFromQs = (qs, field) => {
  try {
    return qs.split("&").find(item => item.includes(field)).split("=")[1];
  } catch (er) {
    console.error( `GetFieldFromQs : field ${field} not found in ${qs}` )
  }
}

export const getShortName = (cookies) => {
  const SoleUser = cookies.get('SoleUser');
  if (SoleUser) {
    return getFieldFromQs(SoleUser, 'shortname')
  }
}
export const getFullName = (cookies) => {
  const SoleUser = cookies.get('SoleUser');
  if (SoleUser) {
    return getFieldFromQs(SoleUser, 'fullname')
  }
}

export const getUserCart = cookies => {
  const SoleUser = cookies.get('SoleUser');
  if (SoleUser) {
    return cookies.get('24orepro-vsf-cart')
  }
}
export const crmDisclaimerConversion = (flagValue) => {
    const parseFlag = parseInt(flagValue);

    if (parseFlag == null) return 3;

    switch (parseFlag) {
        case 0:
            return 2;
        case 1:
            return 1;
        case 2:
            return 3;
        default:
            return 3;
    }
}
export const composeDuMagentoUser = (duCustomer) => {
  const today = new Date();  
  const createdDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDay().toString().padStart(2, "0")}`
    return {
        customer: {
            email: duCustomer.email_address,
            firstname: duCustomer.first_name || duCustomer.last_name,
            lastname: duCustomer.last_name,
            store_id: 1, // Paywall storeID.
            custom_attributes: [
                { attribute_code: "username", value:  duCustomer.username },
                { attribute_code: "flg_mktsoleconsent", value: crmDisclaimerConversion(duCustomer.ConsensoMail) },
                { attribute_code: "flg_mktpurchasesoleconsent", value: crmDisclaimerConversion(duCustomer.ConsensoSocieta) },
                { attribute_code: "flg_mktotherconsent", value: crmDisclaimerConversion(duCustomer.ConsensoProfilazione) },
                { attribute_code: "disclaimer_email", value: 1}, // Hardcoded.
                { attribute_code: "dat_mktsoleconsent", value: createdDate },
                { attribute_code: "dat_mktpurchasesoleconsent", value: createdDate },
                { attribute_code: "dat_mktotherconsent", value: createdDate },
            ]
        }
    }
}